import React from 'react';
import globalconfig from '../../common/config';
import CognitoUtil from '../../aws/cognito/cognitoUtil';
import ReactTable from 'react-table';
import moment from 'moment';
import Select from 'react-select';

import Header from './panels/header';
import ColumnSelector from './columnSelector';
import ColumnCopier from './colmnCopier';
import LngLatLink from '../../widgets/lngLatLink';
import HoverMenu from './panels/hoverMenu';
import { modalConfigs } from './config/modalConfig';


import supporttoolIconProblem from '../raven/panels/Diagnostics/images/supporttool-icon-problem.png';
import supporttoolIconCheckmark from '../raven/panels/Diagnostics/images/supporttool-icon-checkmark.png';
import { Link } from 'react-router-dom';
import RavenDataStore from '../../common/ravenDataStore';

const PAGE_SIZE = 100;

const timeOptions = [
    { value: "hour", label: "Last Hour" },
    { value: "day", label: "Last Day" },
    { value: "week", label: "Last Week" },
    { value: "month", label: "Last Month" },
    { value: "year", label: "Last Year" },
]

const last_event_options = [
    //{ value: "EVENT_ACCIDENT", label: "Accident" },
    { value: "EVENT_RAVEN_UNPLUGGED", label: "Raven Unplugged", id: 5 },
    { value: "EVENT_CAR_BATTERY_LOW", label: "Car Battery Low", id: 6 },
    //{ value: "EVENT_CRASH", label: "Crash" },
    { value: "EVENT_ENGINE_ON", label: "Engine On", id: 19 },
    { value: "EVENT_ENGINE_OFF", label: "Engine Off", id: 20 },
    { value: "EVENT_RAVEN_PLUGGED_IN", label: "Raven Plugged In", id: 21 },
    { value: "EVENT_RAVEN_SHUTDOWN", label: "Raven Shutdown", id: 22 },
    { value: "EVENT_ENGINE_UNKNOWN", label: "Unknown Engine Response", id: 48 },
    { value: "EVENT_UPDATE_REBOOT", label: "Update Reboot", id: 51 },
    { value: "EVENT_UPDATE_COMPLETE", label: "Update Complete", id: 52 },
    { value: "EVENT_RAVEN_BOOTED", label: "Booted", id: 53 },
    { value: "EVENT_RAVEN_USER_SHUTDOWN", label: "User Shutdown", id: 56 },
    { value: "EVENT_UPDATE_FAILED", label: "Update Failed", id: 59 },
    { value: "EVENT_POSSIBLE_IMPACT", label: "Possible Impact", id: 97 },
    { value: "EVENT_RAVEN_CRITICAL_ERROR", label: "Raven Critical Error", id: 116 },
    { value: "EVENT_RAVEN_IMPROPER_SHUTDOWN", label: "Improper Shutdown", id: 122 },
    { value: "EVENT_RAVEN_WARNING", label: "Raven Warning", id: 125 },
]

const last_sd_event_options = [
    { value: "EVENT_STORAGE_SD_CARD_INSERTED", label: "SD Card Inserted", id: 38 },
    { value: "EVENT_STORAGE_SD_CARD_REMOVED", label: "SD Card Removed", id: 39 },
    { value: "EVENT_STORAGE_SD_CARD_ERROR", label: "SD Card Error", id: 40 },
    { value: "EVENT_STORAGE_SD_CARD_NEEDS_FORMAT", label: "SD Card Needs Format", id: 61 },
    { value: "EVENT_STORAGE_SD_CARD_MOUNTED", label: "SD Card Mounted", id: 98 },
    { value: "EVENT_STORAGE_SD_CARD_UNMOUNTED", label: "SD Card Unmounted", id: 99 },
    { value: "EVENT_STORAGE_SD_CARD_NOT_INSERTED", label: "SD Card Not Inserted", id: 100 },
]

const raven_status_options = [
    { value: "PENDING RAVEN RESPONSE", label: "PENDING RAVEN RESPONSE", id: 1 },
    { value: "PROVISIONED", label: "PROVISIONED", id: 2 },
    { value: "SUSPENDED", label: "SUSPENDED", id: 3 },
    { value: "LOST/STOLEN", label: "LOST/STOLEN", id: 4 },
    { value: "DEACTIVATED", label: "DEACTIVATED", id: 5 },
    { value: "PENDING SIM ACTIVATION", label: "PENDING SIM ACTIVATION", id: 6 },
    { value: "PROVISIONING ERROR", label: "PROVISIONING ERROR", id: 7 },
    { value: "PENDING_OTA_UPDATE", label: "PENDING_OTA_UPDATE", id: 8 },
    { value: "RAVENLESS", label: "RAVENLESS", id: 9 },
    { value: "PENDING_REPLACEMENT", label: "PENDING_REPLACEMENT", id: 10 },
    { value: "OVERDUE", label: "OVERDUE", id: 11 },
    { value: "ASSIGNED", label: "ASSIGNED", id: 12 },
]


const styles = {
    dataNumber: {
        textAlign: 'right'
    },
    iconLink: {
        width: '50px',
        height: '50px',
        cursor: 'pointer'
    }
}


class CustomFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value || null
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this.props.value || '' });
        }
    }

    handleChange = (event) => {
        this.setState({ value: event.target.value });
        this.props.onChange(event.target.value);
    }

    render() {
        return (
            <input
                type="text"
                value={this.state.value}
                onChange={this.handleChange}
            />
        );
    }
}

export default class LimitedRaven extends React.Component {

    getDefaultColumns(filters) {

        return [
            {
                Header: 'Raven UUID',
                accessor: 'raven_uuid',
                Cell: (row) => {
                    return (row.value ? <Link to={"/raven/" + this.state.stage + "/" + row.value}> {row.value} </Link> : this.noData)
                },
                selected: true,
                Filter: (filter, row) => {
                    return (
                        <CustomFilter
                            value={this.state.filters['raven_uuid'] ? this.state.filters['raven_uuid'] : filter.value}
                            onChange={value => filter.onChange(value)}
                        />
                    );
                }
            },
            { 
                Header: 'Raven Status',
                accessor: 'raven_status',
                minWidth: 140,
                Cell: (row) => { return (<div>{row.value ? row.value : '-'}</div>) },
                selected: true,
                Filter: (test) => {
                    return (<div>
                        <Select id="ravenType"
                            options={raven_status_options}
                            value={this.state.selectedRavenStatusOption}
                            name="ravenType"
                            isMulti
                            multi
                            onChange={(selectedOption) => {
                                this.setState({ selectedRavenStatusOption: selectedOption });
                                test.onChange(selectedOption ? selectedOption.map(option => option.id) : [], 'raven_status');
                            }}
                            style={{ paddingTop: '5px' }}
                            searchable={false}
                        />
                    </div>);
                }
            },
            {
                Header: 'Raven Firmware',
                accessor: 'raven_os',
                Cell: (row) => { return (<div>{row.value ? row.value : '-'}</div>) },
                selected: true,
                Filter: (filter, row) => {
                    return (
                        <CustomFilter
                            value={this.state.filters['raven_os'] ? this.state.filters['raven_os'] : ''}
                            onChange={value => filter.onChange(value)}
                        />
                    );
                }
            },
            {
                Header: 'ICCID',
                accessor: 'iccid',
                minWidth: 171,
                Cell: (row) => { return row.value ? (<div style={styles.dataNumber}>{row.value}</div>) : this.noData },
                selected: true,
                Filter: (filter, row) => {
                    return (
                        <CustomFilter
                            value={this.state.filters['iccid'] ? this.state.filters['iccid'] : ''}
                            onChange={value => filter.onChange(value)}
                        />
                    );
                }
            },
            {
                Header: 'IMEI',
                accessor: 'imei',
                minWidth: 142,
                Cell: (row) => { return row.value ? (<div style={styles.dataNumber}>{row.value}</div>) : this.noData },
                selected: true,
                Filter: (filter, row) => {
                    return (
                        <CustomFilter
                            value={this.state.filters['imei'] ? this.state.filters['imei'] : ''}
                            onChange={value => filter.onChange(value)}
                        />
                    );
                }
            },
            {
                Header: 'Enclosure Serial Number',
                accessor: 'enclosure_serial_no',
                minWidth: 128,
                Cell: (row) => {
                    return (<div>{row.value ? <Link to={"/raven/" + this.state.stage + "/" + row.value}> {row.value} </Link> : '-'}</div>)
                },
                selected: true,
                Filter: (filter, row) => {
                    return (
                        <CustomFilter
                            value={this.state.filters['enclosure_serial_no'] ? this.state.filters['enclosure_serial_no'] : ''}
                            onChange={value => filter.onChange(value)}
                        />
                    );
                }
            },
            {
                Header: 'Account Email',
                accessor: 'email',
                Cell: (row) => {
                    return (<div>{row.value ? <Link to={"/account/" + this.state.stage + "/" + row.value}> {row.value} </Link> : '-'}</div>)
                },
                selected: true,
                Filter: (filter, row) => {
                    return (
                        <CustomFilter
                            value={this.state.filters['email'] ? this.state.filters['email'] : ''}
                            onChange={value => filter.onChange(value)}
                        />
                    );
                }
            },
            {
                Header: 'Account Name',
                accessor: 'account_name',
                Cell: (row) => { return (<div>{row.value ? row.value : '-'}</div>) },
                selected: true,
                Filter: (filter, row) => {
                    return (
                        <CustomFilter
                            value={this.state.filters['account_name'] ? this.state.filters['account_name'] : ''}
                            onChange={value => filter.onChange(value)}
                        />
                    );
                }
            },
            {
                Header: 'Account ID',
                accessor: 'account_external_id',
                Cell: (row) => { return (<div>{row.value ? row.value : '-'}</div>) },
                selected: true,
                Filter: (filter, row) => {
                    return (
                        <CustomFilter
                            value={this.state.filters['account_external_id'] ? this.state.filters['account_external_id'] : ''}
                            onChange={value => filter.onChange(value)}
                        />
                    );
                }
            },
            {
                Header: 'Vehicle Name',
                accessor: 'vehicle_name',
                Cell: (row) => { return (<div>{row.value ? row.value : '-'}</div>) },
                selected: true,
                Filter: (filter, row) => {
                    return (
                        <CustomFilter
                            value={this.state.filters['vehicle_name'] ? this.state.filters['vehicle_name'] : ''}
                            onChange={value => filter.onChange(value)}
                        />
                    );
                }
            },
            {
                Header: 'Vehicle Type',
                accessor: 'vehicle_info',
                Cell: (row) => { return (<div>{row.value && row.value !== '  ' ? row.value : '-'}</div>) },
                selected: true,
                Filter: (filter, row) => {
                    return (
                        <CustomFilter
                            value={this.state.filters['vehicle_info'] ? this.state.filters['vehicle_info'] : ''}
                            onChange={value => filter.onChange(value)}
                        />
                    );
                }
            },
            {
                Header: 'VIN',
                accessor: 'vin',
                minWidth: 171,
                Cell: (row) => { return (<div>{row.value ? row.value : '-'}</div>) },
                selected: true,
                Filter: (filter, row) => {
                    return (
                        <CustomFilter
                            value={this.state.filters['vin'] ? this.state.filters['vin'] : ''}
                            onChange={value => filter.onChange(value)}
                        />
                    );
                }
            },
            {
                Header: 'Last Update',
                accessor: 'last_update',
                minWidth: 200,
                filterMethod: (filter, row) => {
                    return false; //Forces a call to onFetchData
                },
                Filter: (test) => <div>
                    <Select id="ravenType"
                        options={timeOptions}
                        value={this.state.selectedTimeOption}
                        name="ravenType"
                        onChange={(selectedOption) => {
                            this.setState({ selectedTimeOption: selectedOption });
                            test.onChange(selectedOption ? selectedOption.value : '', 'last_update');
                        }}
                        style={{ paddingTop: '5px' }}
                        searchable={false}
                    />
                </div>,
                Cell: (props) => {
                    if (!props.value) return (<span>-</span>);
                    return (
                        <span title={moment.utc(props.original.last_update).unix()}>
                            {moment(props.value * 1000).format(globalconfig.display.timeFormat)}
                            ( {moment(props.value * 1000).fromNow()} )
                        </span>);
                },
                selected: true

            },
            {
                Header: 'Last GPS Location',
                accessor: 'last_gps',
                Cell: (row) => {
                    let ll = row.value ? row.value.split(",") : [null, null];
                    return (<LngLatLink ll={ll} />)
                },
                selected: true,
                filterable: false
            },
            {
                Header: 'Last Reported Event',
                accessor: 'last_event',
                minWidth: 200,
                Cell: (cellInfo) => {
                    if (!cellInfo.original.last_event) return (<span>-</span>);
                    let event_name = cellInfo.original.last_event.startsWith("EVENT_") ? cellInfo.original.last_event.replaceAll("EVENT_", "") : cellInfo.original.last_event;
                    return (<span>{event_name}</span>);
                },
                selected: true,
                Filter: (test) => {
                    return (<div>
                        <Select id="ravenType"
                            options={last_event_options}
                            value={this.state.selectedLastEventOption}
                            name="ravenType"
                            isMulti
                            multi
                            onChange={(selectedOption) => {
                                this.setState({ selectedLastEventOption: selectedOption });
                                test.onChange(selectedOption ? selectedOption.map(option => option.id) : [], 'last_event');
                            }}
                            style={{ paddingTop: '5px' }}
                            searchable={false}
                        />
                    </div>);
                }
            },
            {
                Header: 'SD Card Status',
                accessor: 'last_sd_event',
                minWidth: 200,
                Cell: (cellInfo) => {
                    const raven = cellInfo.original;
                    const sdCardStatus = raven["last_sd_event"] ? raven["last_sd_event"] : undefined; // 'undefined' to be treated as 'pending'
                    const sdCardStatusIsGood = sdCardStatus !== undefined ? sdCardStatus.toLowerCase().includes("sd card mounted") : false;
                    const sdCardStatusLoadingClass = sdCardStatus !== undefined ? "ready" : "pending";
                    const sdCardStatusIconSrc = sdCardStatusIsGood ? supporttoolIconCheckmark : supporttoolIconProblem;
                    const sdCardStatusTooltip = sdCardStatus ? sdCardStatus : "Unknown State";

                    return (
                        <div className={sdCardStatusLoadingClass}>
                            <div className="status-icon">
                                <img alt='' src={sdCardStatusIconSrc} title={sdCardStatusTooltip} />
                            </div>
                        </div>
                    );
                },
                selected: true,
                Filter: (test) => {
                    return (<div>
                        <Select id="ravenType"
                            options={last_sd_event_options}
                            value={this.state.selectedLastSdEventOption}
                            name="ravenType"
                            isMulti
                            multi
                            onChange={(selectedOption) => {
                                this.setState({ selectedLastSdEventOption: selectedOption });
                                test.onChange(selectedOption ? selectedOption.map(option => option.id) : [], 'last_sd_event');
                            }}
                            style={{ paddingTop: '5px' }}
                            searchable={false}
                        />
                    </div>);
                }
            },
            {
                Header: 'Odometer (KM)',
                accessor: 'odometer',
                Cell: (row) => { return row.value ? (<div style={styles.dataNumber}>{row.value.toLocaleString()}</div>) : this.noData },
                Filter: (filter, row) => {
                    return (
                        <CustomFilter
                            value={this.state.filters['odometer'] ? this.state.filters['odometer'] : filter.value}
                            onChange={value => filter.onChange(value)}
                        />
                    );
                },
                style: styles.dataNumber,
            }
        ];
    }

    noData = ( <div> - </div> );

    NoDataComponent = () =>
        {
            //Keep the same original compnent but add in a button to load all data
            return (
                <div className="rt-noData">
                    {this.state.loading ? (
                        <span>Loading Data...</span>
                    ) : (
                        <div>
                            <span>{this.state.error || "No data loaded. Please enter search criteria to fetch data."}</span>

                            <button className="btn btn-primary" style={{ 'pointerEvents': 'auto' }} onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                console.debug("Loading all ravens with no filters.");
                                this.setState({ loadAll: true });
                            }}>Load All Ravens</button>
                        </div>

                    )}
                </div>
            );
        }

    constructor(props) {
        super(props);

        this.lastRequestId = 0; // Used to ignore old requests

        this.state = {
            ravens: [],
            stage: "",
            filters: {},
            page: (parseInt(this.props.match.params.page) > 0) ? parseInt(this.props.match.params.page) : 1,
            loading: false,
            totalCount: 0,
            columns: [],
            sortBy: null,
            sortOrder: null,
            selectedTimeOption: null,
            selectedLastSdEventOption: null,
            selectedLastEventOption: [],
            selectedRavenStatusOption: null,
            firstLoad: true,
            currentExpanded: {},
        };

        this.callback = null;
        this.raven_unit_id = null;
        this.modal = null;

        this.dataStore = new RavenDataStore((_, data) => {

            if (this.callback && this.raven_unit_id) {
                let newRaven;
                let currentModal;
                this.setState(prevState => {
                    let ravens = prevState.ravens.map(r => {
                        if (r.raven_unit_id === this.raven_unit_id) {
                            newRaven = { ...r }
                            this.callback(newRaven, data);
                            return newRaven;
                        }
                        return r;
                    });

                    if (newRaven) {
                        currentModal = this.renderModal(newRaven, this.modal);
                    }

                    return {
                        ...prevState,
                        ravens,
                        currentModal
                    };
                })
            }
        }, this.props.match.params.stage);
    }

    componentDidMount() {
        // Get the stage from the URL.
        let stage = this.props.match.params.stage;

        // Check if the url contains filters, if so, set the filters in the state
        const urlParams = new URLSearchParams(this.props.location.search);

        let filters = {};
        for (const [key, value] of urlParams.entries()) {
            if (key === 'rv' || key === 'md') continue; // Skip special parameters
            filters[key] = value;
        }

        const savedColumns = this.loadSavedColumns(filters) || undefined;

        this.setState({
            stage: stage,
            filters: filters,
            columns: savedColumns ? savedColumns : this.getDefaultColumns(filters),
            selectedTimeOption: filters['last_update'] ? timeOptions.find(option => option.value === filters['last_update']) : null
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // Check if the URL search string has changed
        if (prevProps.location.search !== this.props.location.search) {
            this.checkUrlForSelectedItem();
        }

        if (this.state.page !== prevState.page
            || JSON.stringify(this.state.filters) !== JSON.stringify(prevState.filters)
            || this.state.sortBy !== prevState.sortBy
            || this.state.sortOrder !== prevState.sortOrder
            || (this.state.loadAll !== prevState.loadAll && this.state.loadAll === true)
            || this.state.pageSize !== prevState.pageSize
        ) {
            const filterUrl = this.state.filters ? Object.keys(this.state.filters).map(key => key + '=' + this.state.filters[key]).join('&') : '';

            this.props.history.push('/smallraven/' + this.state.stage + '/' + this.state.page + '?' + filterUrl);
            const requestId = Date.now();
            this.lastRequestId = requestId;

            //only load data if we have filters, or if we are loading all
            if (Object.keys(this.state.filters).length === 0 && !this.state.loadAll) {
                console.debug("No filters set, unloading data");
                this.setState({ ravens: [], totalCount: 0, loading: false, firstLoad: true, loadAll: false });
                return;
            }

            this.queryRavenUnitsPaged(this.state.page, requestId, (data, requestId) => {
                if (!data || data.length === 0) {
                    console.warn("No data received from server.");
                    this.setState({
                        error: "No data received from server.",
                        loading: false,
                        firstLoad: false
                    });
                    return;
                }

                if (requestId === this.lastRequestId) {
                    this.updateRavenData(data);
                } else {
                    console.log("Ignoring old request", requestId);
                }
            });
        }

    }

    checkUrlForSelectedItem = () => {
        const { location } = this.props;
        const searchParams = new URLSearchParams(location.search);
        const selectedRaven = searchParams.get('rv');
        const selectedModal = searchParams.get('md');
        const modal = modalConfigs.find(m => m.url === selectedModal);
        const unit = this.state.ravens.find(r => r.raven_unit_id === parseInt(selectedRaven));

        if (unit && modal) {
            // An item is selected in the URL
            // Fetch item data if needed and open the modal
            this.setState({
                currentModal: this.renderModal(unit, modal)
            });
        } else {
            // No item is selected, ensure the modal is closed
            this.setState({ currentModal: null });
        }
    };

    /**
     * Loads saved column selections from local storage and updates the default columns
     * based on the provided filters. If no saved columns are found, it returns `false`.
     *
     * @param {Object} filters - The filters used to determine the default columns.
     * @returns {Array|boolean} An array of updated column objects with their `selected` 
     *                          property set based on saved data, or `false` if no saved 
     *                          columns are found.
     */
    loadSavedColumns = (filters) => {
        const saved = localStorage.getItem('selectedColumns');

        if (saved) {
            let columns;
            try {
                columns = JSON.parse(saved);
            } catch (error) {
                console.error("Failed to parse saved columns from local storage:", error);
                columns = null;
            }

            let newColumns = this.getDefaultColumns(filters).map(column => {
                if (columns[column.accessor]) {
                    return { ...column, selected: true };
                } else {
                    return { ...column, selected: false };
                }
            });
            return newColumns;
        }
        return false;
    }


    /**
     * Saves the selected columns to local storage.
     *
     * This function retrieves the previously saved columns from local storage,
     * updates the selection state based on the provided `columns` array, and
     * saves the updated state back to local storage.
     *
     * @param {Array<Object>} columns - An array of column objects. Each object
     *   should have the following properties:
     *   - `accessor` {string}: A unique identifier for the column.
     *   - `selected` {boolean}: Indicates whether the column is selected.
     *
     * @throws {Error} Logs an error if JSON parsing or saving to local storage fails.
     */
    saveColumns = (columns) => {
        let savedColumns = localStorage.getItem('selectedColumns');
        try {
            savedColumns = JSON.parse(savedColumns) || {};
        } catch (error) {
            console.error("Failed to parse saved columns from local storage:", error);
            savedColumns = {};
        }

        columns.forEach(column => {
            if (column.selected) {
                savedColumns[column.accessor] = true;
            } else {
                delete savedColumns[column.accessor];
            }
        });

        try {
            localStorage.setItem('selectedColumns', JSON.stringify(savedColumns));
        } catch (error) {
            if (error.name === 'QuotaExceededError') {
                console.error("Local storage quota exceeded. Unable to save selected columns.");
            } else {
                console.error("An error occurred while saving selected columns:", error);
            }
        }
    }

    /**
     * Updates the state with the provided raven data.
     * If the `ravens` array is empty after removing the last element, 
     * it resets the page to 1 and sets the total count and ravens to their respective values.
     * Otherwise, it updates the state with the remaining ravens and the total count.
     * Finally, it sets the loading and firstLoad flags to false.
     *
     * @param {Array} ravens - An array of raven objects. The last element is expected to contain a `count` property.
     */
    updateRavenData = (ravens) => {
        let count = ravens.pop().count;
        if (ravens.length === 0) {
            this.setState({
                page: 1,
                totalCount: count,
                ravens: [],
                currentExpanded: {}
            });
        } else {
            this.setState({
                ravens: ravens,
                totalCount: count,
                currentExpanded: {}
            });
        }
        this.setState({ loading: false, firstLoad: false });
    }

    /**
     * Get a token from the API using our cognito token.
     * @returns - The token from the API.
     * @throws - An error if a token is not found.
     */
    grabToken(callback, queryUrl, requestId, queryCallBack) {
        const token = CognitoUtil.getCurrentUserToken();
        const url = this.buildApiUrl() + 'auth/token';

        fetch(url, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token
            }
        }).then(response => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Failed to fetch token.');
        }
        ).then(data => {
            callback(queryUrl, data.token, requestId, queryCallBack);
            return;
        }).catch(error => {
            console.error(error);
        });
    }

    queryServer(url, token, requestId, callback) {
        if (!token) {
            console.error("No token received, quitting.");
            return;
        }

        fetch(url, {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token,
            }
        }).then(response => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Failed to fetch Raven units.');
        }).then(data => {
            callback(data, requestId);
            return
        }).catch((error) => {
            console.error(error);
            callback([], requestId); // Return empty array on error
        });
    }

    buildSearchUrl() {
        console.debug("Building search URL with sortBy:", this.state.sortBy, "sortOrder:", this.state.sortOrder, "filters:", this.state.filters);
        let search_url = ""
        Object.keys(this.state.filters).forEach(filterKey => {
            search_url += "&" + filterKey + "=" + encodeURIComponent(this.state.filters[filterKey]);
        });
        if (this.state.sortBy) {
            search_url += "&sort=" + this.state.sortBy;
            search_url += "&order=" + this.state.sortOrder;
        }
        return search_url;
    }

    buildApiUrl() {
        const stage = this.props.match.params.stage;
        const BASE_URL_TEMPLATE = process.env.REACT_APP_RC_API_BASE_URL;
        const dotstage = "prod" === stage ? "" : `.${stage}`;
        return BASE_URL_TEMPLATE.replace('{.stage}', dotstage)
    }

    /**
     * 
     * @param {*} page - The page number to query from the server
     * @param {*} callback - The callback function to call when the data is returned from the server.
     */
    async queryRavenUnitsPaged(page, requestId, callback) {
        console.debug("Querying page", page, "with filters", this.state.filters);
        this.setState({ loading: true });
        let url = this.buildApiUrl()
            + 'support/ravens'
            + '?page=' + page
            + '&limit=' + (this.state.pageSize || PAGE_SIZE);

        if (Object.keys(this.state.filters).length > 0 || this.state.sortBy)
            url += this.buildSearchUrl();

        console.debug("Query URL:", url);

        this.grabToken(this.queryServer, url, requestId, callback);
    }

    /**
     * Update the filters to query the cloud for
     * @param {*} filters - The filters to apply to the data.
     * @returns - A list of filters to apply to the data.
     */
    updateFilters(filters) {
        let filterList = {};
        filters.forEach(filter => {
            // If it's empty value, or empty array ignore it
            if (filter.value === '' || (Array.isArray(filter.value) && filter.value.length === 0))
                return;
            filterList[filter.id] = filter.value;
        });
        //update the url with the new filters
        let filterUrl = "";
        Object.keys(filterList).forEach(key => {
            if (filterUrl.length === 0) {
                filterUrl += key + "=" + encodeURIComponent(filterList[key]);
            } else {
                filterUrl += "&" + key + "=" + encodeURIComponent(filterList[key]);
            }
        });
        this.props.history.push('/smallraven/' + this.state.stage + '/' + this.state.page + '?' + filterUrl);
        return filterList;
    }

    /**
     * Check if there is a filter applied to the data, if the page has chnaged.
     * This is called from the react-table onFetchData function, which is called any time sorting, pagination or filterting is changed in the table
     * @param {} state - The state from the react-table component at the time of the fetch.
     * @param {*} instance - The react-table's instance object at time of the fetch, largely ignored here
     */
    handleDataFetch(state, instance) {
        // Filters are under state.filtered (list)
        // Sorting is under state.sorted (list)
        let { sorted } = state;
        // Ignore this call on the first load, filters may not be set yet and we don't want to set them to nothing
        if (this.state.firstLoad) return;

        console.debug("Table state changed, checking for changes in filters, sorting or page number.", state);
        //this.setState({ loading: true });
        let newPage;
        if (state.page !== this.state.page) newPage = state.page + 1;

        this.setState({
            page: newPage,
            sortBy: sorted[0] && this.state.filters ? sorted[0].id : null,
            sortOrder: sorted[0] ? (sorted[0].desc ? "desc" : "asc") : null
        });
    }

    handleFilterChange(filters) {
        let updatedFilters = this.updateFilters(filters);
        //if there are no more filters, clear sortby as well, otherwise just update the filters
        this.setState({
            filters: updatedFilters,
            sortBy: Object.keys(updatedFilters).length === 0 ? null : this.state.sortBy,
            sortOrder: Object.keys(updatedFilters).length === 0 ? null : this.state.sortOrder,
            page: 1, // Reset to first page when filters change
            loadAll: false
        });
    }

    debounce(func, wait, immediate) {
        let timeout;
        return function () {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                timeout = null;
                if (!immediate) func.apply(this, arguments);
            }, wait);
        }
    }

    // Debounce the handleDataFetch function to prevent multiple calls to the server when the user is typing in the search box.
    debouncedHandleDataFetch = this.debounce(this.handleDataFetch, 300);
    debouncedHandleFilterChange = this.debounce(this.handleFilterChange, 300);

    /**
     * Render the raven table using react-table.
     */
    renderReactRavenTable(ravens) {
        let { columns } = this.state;

        columns = columns.filter(column => column.selected);

        /**TODO:s
         * Bold some important items (e.g. UUID) name the classes
         *  Horizontal light grey lines between rows
         *  Select multiple ravens and then show them on the map
         * 
         */

        console.debug("Rendering table with columns:", columns);
        const filters = Object.keys(this.state.filters).map((key) => {
            const value = this.state.filters[key];
            return {
                id: key,
                value: value
            }
        });

        const noDataText = this.state.loading ? "Loading Data..." : this.state.error || "No data loaded. Please enter search criteria to fetch data.";

        return (
            <div id="raven-listing" className="raven-list">
                <ReactTable className="-striped"
                    data={ravens ? ravens : []}
                    filterable
                    filtered={filters}
                    //defaultFilterMethod={(filter, row) => String(row[filter.id]).includes(filter.value)}
                    showPagination={true}
                    showPageSizeOptions={true}
                    pageSize={this.state.pageSize || PAGE_SIZE}
                    pageSizeOptions={[10, 20, 50, 100, 200, 500, 1000]}
                    onPageSizeChange={(pageSize, pageIndex) => { this.setState({ pageSize: pageSize, page: 1 }); }}
                    showPageJump={true}
                    page={this.state.page - 1}
                    pages={Math.ceil(this.state.totalCount / (this.state.pageSize || PAGE_SIZE))}
                    style={{ height: "87vh", maxWidth: '100vw' }}
                    columns={columns}
                    NoDataComponent={ this.NoDataComponent }
                    noDataText={noDataText}
                    manual
                    minRows={0}
                    onFetchData={
                        (state, instance) => {
                            this.debouncedHandleDataFetch(state, instance);
                        }
                    }
                    onPageChange={(pageIndex) => this.setState({ page: pageIndex + 1 })}
                    onFilteredChange={(filters) => {
                        this.debouncedHandleFilterChange(filters);
                    }}
                    loading={this.state.loading}
                    SubComponent={row => {
                        return (
                            <div >
                                <HoverMenu id={row.index}
                                    unit={row.original}
                                    ravenStage={this.state.stage}
                                    openModal={this.openModal} />
                            </div>
                        );
                    }}
                    onExpandedChange={
                        (newExpanded, index, event) => {
                            if (newExpanded[index]) {
                                this.setState({ currentExpanded: { ...this.state.currentExpanded, [index]: true } });
                            } else {
                                //Remove index from state
                                this.setState({ currentExpanded: { ...this.state.currentExpanded, [index]: false } });
                            }
                        }
                    }
                    expanded={this.state.currentExpanded}
                    LoadingComponent={({ className, loading, loadingText, ...rest }) => {
                        if (!loading) return null;

                        return (
                            <div className="table-loading-overlay">
                                <div className="table-loading-container">
                                    <div className="loading-activity-indicator">
                                        <div></div><div></div><div></div><div></div><div></div><div></div>
                                        <div></div><div></div><div></div><div></div><div></div><div></div>
                                    </div>
                                    <h4>{loadingText || "Loading data..."}</h4>
                                </div>
                            </div>
                        );
                    }}
                    getPaginationProps={() => {
                        return { pageText: `Total ${this.state.totalCount} rows, Page` }
                    }}
                />
            </div>
        );
    }

    /**
     * Download the data in the current table as a CSV file.
     * Currently limited to only the current page of data.
     * 
     */
    downloadCSV() {
        let csvContent = "data:text/csv;charset=utf-8,";
        let headers = this.state.columns.map(column => column.Header);
        csvContent += headers.join(",") + "\n";
        let data = this.state.ravens;
        if (data.length === 0) return;

        data.forEach(raven => {
            let row = this.state.columns.map(column => {
                let value = raven[column.accessor];
                if (typeof value === 'string')
                    value = value.replace(/,/g, ' '); // Escape commas

                return value || '';
            });
            csvContent += row.join(",") + "\n";
        });

        let encodedUri = encodeURI(csvContent);
        window.open(encodedUri);
    }

    handleStageChange = (stage) => {
        this.props.history.push("/smallraven/" + stage + '/1');

        //change the stage, and clear the current filters
        this.setState({ stage: stage, filters: {}, page: 1, 
                loadAll: false, selectedTimeOption: null, 
                selectedLastEventOption: [], selectedLastSdEventOption: [],
                sortBy: null, sortOrder: null, selectedRavenStatusOption: null });
    }

    /**
     * Handles changes to the checkbox selection and updates the state with the modified columns.
     *
     * @param {Array<Object>} updatedColumns - An array of column objects with updated selection states.
     * @param {string} updatedColumns[].accessor - The unique identifier for the column.
     * @param {boolean} updatedColumns[].selected - The updated selection state of the column.
     *
     * Updates the state with the modified columns and saves the changes, does not return anything.
     */
    handleCheckboxChange = (updatedColumns) => {
        let columns = [...this.state.columns];

        updatedColumns.forEach(updatedColumn => {
            const index = columns.findIndex(col => col.accessor === updatedColumn.accessor);
            if (index !== -1) {
                columns[index] = { ...columns[index], selected: updatedColumn.selected };
            }
        });

        this.setState({ columns: columns }, () => this.saveColumns(columns));
    }

    handleDataCopyRequest = (selectedColumn) => {
        return this.state.ravens.map(raven => raven[selectedColumn]);
    }

    openModal = (unit, modalInfo) => {
        const { history, location } = this.props;

        // Use URLSearchParams to easily manage query strings
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('rv', unit.raven_unit_id);
        searchParams.set('md', modalInfo.url);

        this.callback = modalInfo.callback;
        this.raven_unit_id = unit.raven_unit_id;
        this.modal = modalInfo;

        // Push the new URL to the browser's history
        history.push(`${location.pathname}?${searchParams.toString()}`);
    }

    renderModal = (unit, modalInfo) => {
        const ravenEnclosureSN = unit.enclosure_serial_no;

        let title = "" + modalInfo.title + " for Raven Unit " + ravenEnclosureSN + " (" + unit.email + ")";
        if (globalconfig.features.ravens.vendorDetailsPreferred) {
            const accountExternalId = unit.account_external_id;
            if (ravenEnclosureSN && accountExternalId) {
                title = "" + modalInfo.title + " for Raven Unit " + ravenEnclosureSN + " (" + accountExternalId + ")";
            }
        }

        let ModalComponent = modalInfo.component;

        // For Raven History
        const today = moment().format('ddd MMM DD HH:mm:ss YYYY');
        const sevenDaysAgo = moment().subtract(7, 'days').format('ddd MMM DD HH:mm:ss YYYY');
        unit.sensordaterange = [sevenDaysAgo, today];

        return (
            <ModalComponent title={title} isOpen={true}
                routeProps={this.props}
                raven={unit}
                dataStore={this.dataStore}
                stage={this.state.stage}
                onClose={this.closeModal}
            />
        );
    }

    closeModal = () => {
        const { history, location } = this.props;

        const searchParams = new URLSearchParams(location.search);
        searchParams.delete('rv');
        searchParams.delete('md');

        // Push the cleaned URL to history
        history.push(`${location.pathname}?${searchParams.toString()}`);
    }

    clearAllFilters = () => {
        this.setState({
            filters: {},
            page: 1,
            loadAll: false,
            selectedTimeOption: null,
            selectedLastEventOption: [],
            selectedLastSdEventOption: [],
            sortBy: null,
            sortOrder: null,
            selectedRavenStatusOption: null
        });
    }

    render() {
        let columnsForSelector = this.state.columns.map((column) => {
            return {
                accessor: column.accessor,
                selected: column.selected,
                Header: column.Header
            }
        });

        return (
            <div style={{ maxWidth: '100vw' }}>
                <Header
                    ravenStages={this.props.stages}
                    stage={this.props.match.params.stage}
                    onRavenStageChange={this.handleStageChange}
                />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <ColumnSelector columns={columnsForSelector} handleCheckboxChange={this.handleCheckboxChange} />
                    <ColumnCopier
                        columns={columnsForSelector}
                        getColumnData={this.handleDataCopyRequest}

                    />
                    <button className='btn btn-primary' onClick={this.clearAllFilters}>Clear Filters</button>
                    <img src="/images/baseline_cloud_download_white_18dp.png" alt="Export" onClick={this.downloadCSV.bind(this)} style={styles.iconLink} />
                </div>
                <div style={{ display: 'flex' }}>
                    <div style={{ flex: 1 }}>
                        {this.renderReactRavenTable(this.state.ravens)}
                    </div>
                </div>
                {this.state.currentModal}
            </div>
        );
    }
}